module.exports = __webpack_public_path__ + "img/xinyong.12229584.png";